import request from './request'
const activity = 'ACTIVITY-SERVE'

// 活动集客列表
export function actCustomerfindList(data) {
  return request({
    url: activity + '/act-customer-info/findList',
    method: 'post',
    data
  })
}

// 物料审核状态 列表接口
export function pageList(data) {
  return request({
    url: activity + '/materialInformation/pageList',
    method: 'post',
    data
  })
}

// 物料审核状态 详情接口
export function findByIdDetails(data) {
  return request({
    url: activity + '/materialInformation/findById/' + data,
    method: 'get'
  })
}

// 推广活动审核查询 列表接口
export function pageTuiGuangList(data) {
  return request({
    url: activity + '/activityApply/pageList',
    method: 'post',
    data
  })
}

// 推广活动审核查询 详情接口
export function findByIdTuiGuangDetails(data) {
  return request({
    url: activity + '/activityApply/findById/' + data,
    method: 'get'
  })
}


// 报账审批进度查询 列表接口
export function pageBaoZhangList(data) {
  return request({
    url: activity + '/activityReimbursement/pageList',
    method: 'post',
    data
  })
}

// 报账信息审核信息查看  详情接口
export function findByIdBaoZhangDetails(data) {
  return request({
    url: activity + '/activityReimbursement/findById/' + data,
    method: 'get'
  })
}


// 活动集客信息保存
export function saveActCustomer(data) {
  return request({
    url: activity + '/act-customer-info/save',
    method: 'post',
    data
  })
}
// 活动集客删除
export function deleteActCustomer(data) {
  return request({
    url: activity + '/act-customer-info/delete',
    method: 'post',
    data
  })
}
// 活动集客详细
export function detailActCustomer(data) {
  return request({
    url: activity + '/act-customer-info/detail?id=' + data,
    method: 'get'
  })
}
// 导入活动集客信息
export function uploadActCustomer(data) {
  return request({
    url: activity + '/act-customer-info/upload',
    method: 'post',
    data
  })
}
// 导出活动集客信息
export function exportActCustomer(data) {
  return request({
    url: activity + '/act-customer-info/export',
    method: 'post',
    responseType: 'blob',
    data
  })
}
